import { MAX_WORD_LENGTH } from './settings';
import { wordValidation } from './quenyaRule';

/* // corpus from https://folk.uib.no/hnohf/qlist.htm
  const corpA = [];
  document.queryselectorAll('p:nth-child(10) > br + b')
    .forEach(e => corpA.push(e.innerText));
  // corpus from https://folk.uib.no/hnohf/quen-eng.htm
  const corpB = [];
  document.queryselectorAll('p > b:first-child')
    .forEach(e => corpB.push(e.innerText));
  // combined
  const corpus = [...(new Set([...corpA, ...corpB]))];
*/
const corpus = [
  'a',
  'acas',
  'acca',
  'Acairis',
  'acúna',
  'Ae',
  'aha',
  'ahosta',
  'ahtar',
  'ai',
  'aia',
  'aian',
  'aica',
  'aicale',
  'Aicanáro',
  'aicasse',
  'ailin',
  'ailine',
  'ailo',
  'aimenal',
  'ainas',
  'Aini',
  'ainima',
  'Aino',
  'Ainu',
  'aipio',
  'aiqua',
  'aiqualin',
  'aiquen',
  'aira',
  'aire',
  'airea',
  'airon',
  'aiwe',
  'Aiwenor',
  'al',
  'ala',
  'alaco',
  'alahasta',
  'alaie',
  'alalme',
  'alalmino',
  'alalvea',
  'alalvinore',
  'Alamanya',
  'álame',
  // 'alan',
  'alanesse',
  'alaquenta',
  // 'alar',
  // 'Aláriel',
  'alarca',
  'alas',
  'alasaila',
  'alasse',
  'alat',
  'Alataire',
  'alatúlie',
  'alatulya',
  'alca',
  'alcantaméren',
  'alcar',
  'alcarin',
  'alcarinqua',
  'alcarain',
  'alcarissen',
  'Alcorin',
  'alda',
  'Aldalemnar',
  'Aldaron',
  'aldarwa',
  'Aldea',
  'aldeon',
  'alenesse',
  'aldinga',
  'alima',
  // 'alla',
  'alle',
  // 'allen',
  'alma',
  'almare',
  'almárea',
  'Almaren',
  'Almáriel',
  'alme',
  'almie',
  'Almiel',
  'alqua',
  'Alqualonde',
  'Alquaráme',
  'Altariel',
  'alu',
  'alve',
  'alwa',
  'alye',
  'ama',
  'amal',
  'amaldar',
  'aman',
  'amandi',
  'amanya',
  'Amarie',
  'amarto',
  'amatixe',
  // 'amatúlie',
  // 'amatulya',
  'amaurea',
  'amba',
  'ambal',
  'Ambalar',
  'ambale',
  'ambalotse',
  'amban',
  'ambapenda',
  'ambar',
  'Ambarenya',
  'ambaron',
  'Ambaróna',
  'Ambaróne',
  'Ambarto',
  'ambas',
  'ambasse',
  'Ambarussa',
  'ambe',
  'ambela',
  'ambena',
  'ambo',
  'ambos',
  'ambuna',
  'ámen',
  'amil',
  'Amillion',
  'amilye',
  'ammale',
  'amme',
  'amna',
  'ampa',
  'ampano',
  'ampenda',
  'ampende',
  'amu',
  'amun',
  'amunte',
  'an',
  'ana',
  'anaie',
  'Anamo',
  'anan',
  'ananta',
  'Anar',
  'anarcande',
  'anat',
  'anaróre',
  'anca',
  'Ancale',
  'ancalima',
  'anda',
  'Andafalasse',
  'andamacil',
  'andamunda',
  'andanéya',
  'andatehta',
  'andave',
  'ando',
  'Andolat',
  'andon',
  'Andóre',
  'andú',
  'andúna',
  'andúne',
  'Anduine',
  'Andúnie',
  'Andustar',
  'áne',
  'ane',
  'anel',
  'anesse',
  'anga',
  'angaina',
  'angaitya',
  'Angamando',
  'angayanda',
  'angayasse',
  'ango',
  'angulóce',
  'ánie',
  'anna',
  'anni',
  'aññol',
  'anon',
  'anquale',
  'antara',
  'ante',
  'antil',
  'anto',
  'antoryame',
  'antúlien',
  'anyára',
  'anwa',
  'anwe',
  'anwet',
  'apa',
  'apacenye',
  'apaire',
  'Apanónar',
  'aparuive',
  'apo',
  'apsa',
  'aqua',
  'aquapahtie',
  'aquet',
  'ar',
  'Ar Fanturion',
  'Ar Manwen',
  'Ar Ulmon',
  'Ar Veruen',
  'ára',
  'ara',
  'Araman',
  'aranel',
  'aranie',
  'aranus',
  'Aranwe',
  'aranya',
  'aranye',
  'Aratan',
  'arata',
  'arato',
  'aráto',
  'arauca',
  'arauco',
  'arcande',
  'Arciryas',
  'arda',
  'arde',
  'are',
  'áre',
  'Arfanyaras',
  'arie',
  'Arien',
  'ari',
  'arin',
  'arinya',
  'arma',
  'armar',
  'armaro',
  'arme',
  'armet',
  'Armenelos',
  'Arnanóre',
  'arni',
  'arquen',
  'arse',
  'arta',
  'Artaher',
  'Artamir',
  'Artanis',
  'artarindo',
  'artaure',
  'arte',
  'artuile',
  'Arvalin',
  'Arvernien',
  'Arveruen',
  'arwa',
  'arwe',
  'Aryante',
  'aryon',
  'as',
  'asa',
  'asalaste',
  'asambar',
  'asanóte',
  'asar',
  'ascene',
  'asea',
  'asie',
  'assa',
  'assari',
  'asta',
  'astar',
  'astarindo',
  'astarmo',
  'aste',
  'Astaldo',
  'asto',
  'astye',
  'ata',
  'ataformaite',
  'ataformo',
  'atalantea',
  'Atan',
  'ataque',
  'ataquetie',
  'atar',
  'atarme',
  'ataryo',
  'atatya',
  'atendea',
  'atsa',
  'atta',
  'attaformaite',
  'attaformo',
  'attalaite',
  'attea',
  'atto',
  'atquetie',
  'atya',
  'atwa',
  'au',
  'aule',
  'Aulendil',
  'Aulendur',
  'Auleonnar',
  'aure',
  'Aurel',
  'ausa',
  'ausie',
  'aute',
  'Auzel',
  'áva',
  'ava',
  'Avacúma',
  'avahaira',
  'Avallóne',
  'Avamanyar',
  'avánie',
  'avanir',
  'avanóte',
  'avanwa',
  'avanyárima',
  'avaquétima',
  'avar',
  'Avasar',
  'avestalis',
  'awalda',
  'axa',
  'axan',
  'axe',
  'axo',
  'áya',
  'áyan',
  'az',
  'áze',
  'ca',
  'cá',
  'caila',
  'caima',
  'caimasan',
  'caimasse',
  'caimassea',
  'caina',
  'caine',
  'cainen',
  'caire',
  'caista',
  'caivo',
  'caivocalma',
  'cala',
  'Calacilya',
  'Calacirya',
  'Calaciryan',
  'Calainis',
  'Calamando',
  'calambar',
  'Calamor',
  'calasse',
  'Calaquendi',
  'calar',
  'calarus',
  'Calavéne',
  'Calavente',
  'calca',
  'cále',
  'calima',
  'Calimehtar',
  'Calimmacil',
  'calina',
  'Calion',
  'Caliondo',
  'calliére',
  'callo',
  'calma',
  'Calmacil',
  'calmatan',
  'calmatéma',
  'calwa',
  'cáma',
  'camba',
  'cambe',
  // 'can-',
  'cana',
  'Canafinwe',
  'canaque',
  'canasta',
  'cáne',
  'cáno',
  // 'cansat',
  'canta',
  'cantea',
  'cantil',
  'canuva',
  'canwa',
  'canwe',
  'canya',
  'capalinda',
  'cár',
  'car',
  'carampe',
  'carasse',
  'cari',
  'caraxe',
  'carca',
  'carcane',
  'carcaras',
  'carco',
  'carda',
  'carma',
  'Carme',
  'carna',
  'carne',
  'carneambarai',
  'carnevaite',
  'carnevalinar',
  'Carnil',
  'carnimírea',
  'Carnistir',
  'cáro',
  'carpa',
  'carpasse',
  'carrea',
  'carva',
  'cas',
  'Casar',
  'cassa',
  'cast',
  'casta',
  'Castamir',
  'castol',
  'cata',
  'cauca',
  'cauco',
  'cauma',
  'caure',
  'caurea',
  'cautáron',
  'cé',
  'cea',
  'Celecorna',
  'celma',
  'celu',
  'celume',
  'celusindi',
  'celusse',
  'celvar',
  'cemen',
  'cemenáro',
  'Cemendur',
  'cemi',
  'cemina',
  'cemna',
  'cemnaro',
  'cén',
  'cenai',
  'cenasit',
  'cende',
  'cendele',
  'cenima',
  'centa',
  'centano',
  'Cermie',
  'certa',
  'ceula',
  'ceule',
  'ceura',
  'ceuran',
  'ceuranar',
  'ceure',
  'céva',
  'cilde',
  'cildo',
  'cilin',
  'cilintilla',
  'cilinyul',
  'cilme',
  'ciluva',
  'cilya',
  'cinta',
  'círa',
  'circa',
  'círier',
  'cirinci',
  'ciris',
  'cirisse',
  'cirte',
  'cirya',
  'ciryamo',
  'ciryando',
  'ciryaquen',
  'coa',
  'coi',
  'coace',
  'coimas',
  'coina',
  'coire',
  'coirea',
  'coite',
  'coiva',
  'coivie',
  'Coivienéni',
  'colca',
  'colindo',
  'colla',
  'colma',
  'cólo',
  'combe',
  'condo',
  'cópa',
  'coranar',
  'corco',
  'corda',
  'cordon',
  'corima',
  'corin',
  // 'Corlaire',
  'Corollaire',
  'corma',
  'corme',
  'cormen',
  'corna',
  'corne',
  'Coroloisi',
  'Corollaire',
  'Corolóra',
  'coromindo',
  'coron',
  'Cosmoco',
  'cotto',
  'cotumo',
  'cotya',
  'cú',
  'cua',
  'cucua',
  'cuina',
  'cuiva',
  'cuive',
  'cuivea',
  'cuivie',
  'culda',
  'culina',
  'cullo',
  'culo',
  'culucalmalínen',
  'culuina',
  'culuma',
  'culumalda',
  'Culúrien',
  'culuvai',
  'cúma',
  'cumbe',
  'cumna',
  'cúna',
  'cundo',
  'cundu',
  'cúne',
  'cunta',
  'curo',
  'curu',
  'Curufinwe',
  'Curumo',
  'curuni',
  'curuvar',
  'Curvo',
  'curwe',
  'da',
  'dil',
  'duine',
  'dur',
  'é',
  'Ea',
  'eala',
  'Eambar',
  'ear',
  'earen',
  'Earendil',
  'Earnil',
  'Earnur',
  'earon',
  'ec',
  'ecca',
  'eccaira',
  'eces',
  'ecco',
  'ecet',
  'ecya',
  // 'effírie',
  'ehtar',
  'ehte',
  'ehtele',
  'ehtyar',
  'Ekkaia',
  'él',
  'ela',
  'Elatan',
  'elda',
  'Eldacan',
  'Eldacar',
  'Eldalambe',
  'Eldalie',
  'Eldamar',
  'Eldameldor',
  'Eldandil',
  'Eldanor',
  'Eldanyáre',
  'Eldarin',
  'Eldarissa',
  'Eldavehte',
  'Eldo',
  'éle',
  'Elemmíre',
  'elen',
  'elena',
  'Elenarda',
  'Elende',
  'elende',
  'Elendil',
  'Elendur',
  'Elenna',
  'Elentári',
  'Elenwe',
  'elenya',
  'Elerína',
  'Elerondo',
  'Elerosse',
  'Elerrína',
  'Elessar',
  'Elesser',
  'Ellaire',
  'elle',
  'ello',
  'elme',
  'elmenda',
  'Elpino',
  'elvea',
  'Elwe',
  'elwen',
  'elye',
  'emel',
  'emenya',
  'emerwen',
  'emil',
  'emma',
  'emme',
  'emya',
  'en',
  // 'ence',
  'enda',
  'Endamar',
  'ende',
  'endea',
  'Ender',
  'enderi',
  'Endien',
  'Endor',
  'endya',
  'enel',
  'enelde',
  'enelmo',
  'enenque',
  'enetya',
  'enga',
  'enge',
  'engie',
  'engwa',
  'enna',
  'enque',
  'enquesta',
  'enquie',
  'enta',
  'Entar',
  'Entarda',
  'ente',
  'ento',
  'entulesse',
  'entya',
  'Enu',
  'Envinyatar',
  'envinyanta',
  'enwa',
  'enwina',
  'enya',
  'enyáre',
  'Eonwe',
  'epe',
  'epesse',
  'epeta',
  'epetai',
  'epta',
  'eque',
  'eques',
  'er',
  'erca',
  'Ercambo',
  'ercasse',
  'Ercoire',
  'erda',
  'erde',
  'ere',
  'erea',
  'Eremandu',
  'eresse',
  'eressea',
  'erinqua',
  'Erintion',
  'erma',
  'Erquelle',
  'Erríve',
  'Ertuile',
  'Eru',
  'Eruman',
  'erume',
  'erúmea',
  'Eruva',
  'erya',
  'es',
  // 'esce',
  'esse',
  'essea',
  'Esselda',
  'esta',
  'estat',
  'Este',
  'estel',
  'esto',
  'et',
  'etelye',
  'etelle',
  'eteminya',
  'etemme',
  'etengwe',
  'etse',
  'etsir',
  'etta',
  'ette',
  'ettele',
  'ettelea',
  'etya',
  'Etyangoldi',
  'euva',
  'evandilyon',
  'exa',
  'exe',
  'éye',
  'ezel',
  'Ezellohar',
  'faica',
  'faila',
  'faire',
  'fairie',
  'Falanyel',
  'falas',
  'falastane',
  'Falastur',
  'falle',
  'falma',
  'falmar',
  'falqua',
  'falquan',
  'fána',
  'fana',
  'fáne',
  'fanga',
  'fange',
  'fantarcenya',
  'Fantur',
  'fanwa',
  'fanwos',
  'fanya',
  'Fanyamar',
  'fanyare',
  'fára',
  'fáre',
  'faren',
  'fárea',
  'farinye',
  'farma',
  'farme',
  'farne',
  'fas',
  'fáse',
  'fasse',
  'fatanyu',
  'fatse',
  'fauca',
  'fáwe',
  'Fayanáro',
  'fazne',
  'fea',
  'fealóce',
  'Feanáro',
  'fel',
  'felca',
  'felco',
  'felehta',
  'felya',
  'felme',
  'felu',
  'fen',
  'fenda',
  'fenna',
  'fenume',
  'feren',
  'férima',
  'ferinya',
  'ferna',
  'ferne',
  'ferya',
  'feuya',
  'filit',
  'fimbe',
  'finca',
  'finda',
  'Findaráto',
  'finde',
  'Findecáno',
  'findel',
  'findele',
  'findesse',
  'findile',
  'findl',
  'fine',
  'fínea',
  'finie',
  'fintale',
  'finwa',
  'Finwe',
  'finya',
  'fion',
  'Fionwe',
  'firie',
  'fire',
  'Fíriel',
  'fírima',
  'Fírimo',
  'firin',
  'firinga',
  'Firya',
  'Firyanor',
  'fó',
  'foa',
  'foalóce',
  'foina',
  'fóle',
  'fólima',
  'Follondie',
  'forma',
  'formaite',
  'Formen',
  'formenya',
  'forna',
  'Forolondie',
  'Forostar',
  'forte',
  'forya',
  // In Quenya 'fu' sounds like 'hu'
  /* 'Fui',
  'fuine',
  'Fuinur',
  'fúme',
  'fúmella',
  'fúmellot',
  'funda',
  'furin',
  'furu', */
  'hácala',
  'hacca',
  'hahta',
  'haime',
  'haira',
  'haiya',
  'hala',
  'halatir',
  'halcin',
  'halda',
  'halla',
  'Hallacar',
  'Hallatan',
  'halma',
  'haloisi',
  'haloite',
  'hamma',
  'hampa',
  'han',
  'hanaco',
  'handa',
  'handasse',
  'hande',
  'handele',
  'hando',
  'háno',
  'hanno',
  'hanquenta',
  'hantale',
  'hante',
  'hanu',
  'hanuvoite',
  'hanwa',
  'har',
  'haran',
  'haranye',
  'harda',
  'harin',
  'harma',
  'Harmen',
  'harna',
  'harpa',
  'harwe',
  'haryon',
  'hat',
  'hatal',
  'hatse',
  'haura',
  'háya',
  'hé',
  'heca',
  'Hecel',
  'hecil',
  'hela',
  'helca',
  'helce',
  'helcelimbe',
  'helda',
  'heldo',
  'helme',
  'helin',
  'Helinyetille',
  'helle',
  'helma',
  'helwa',
  'helyanwe',
  'hen',
  'hendumaica',
  'henfanwa',
  'hententa',
  'henulca',
  'hequa',
  'hér',
  'héra',
  'hére',
  'heren',
  'herenya',
  'heri',
  'hérince',
  'Hescin',
  'Hesin',
  'hessa',
  'hesto',
  'hí',
  'hilcin',
  'hildi',
  'Hildor',
  'himba',
  'himya',
  'hína',
  'hir',
  'híse',
  'hísen',
  'hísie',
  'hísilanya',
  'Hísilóme',
  'Hísilumbe',
  'Hísime',
  'histane',
  'histe',
  'hiswa',
  'hiswe',
  'hlaiwa',
  'hlas',
  'hlíne',
  'hlíve',
  'hloa',
  'hlóce',
  'hloima',
  'hloire',
  'hloirea',
  'hlón',
  'hlóna',
  'hlonite',
  'hloníte',
  'hlussa',
  'ho',
  'hó',
  'hoa',
  'holme',
  'holwe',
  'hón',
  'hondoninya',
  'hópa',
  'hopan',
  'hopasse',
  'hóre',
  'horma',
  'horme',
  'horro',
  'hortale',
  'horya',
  'hos',
  'hosse',
  'hosta',
  'hostar',
  'hrá',
  'hrai',
  'hraia',
  'hraicénima',
  'hranga',
  'hráva',
  'hravan',
  'hráve',
  'hresta',
  'hrisse',
  'hristil',
  'Hristo',
  'hríve',
  'hroa',
  'Hróatani',
  'hrómen',
  'hrón',
  'hrondo',
  'hróna',
  'hróta',
  'hróva',
  'hru',
  'hrúcare',
  'hruo',
  // 'fu' to 'hu'?
  'hú',
  'hu',
  'huan',
  'hue',
  'Hui',
  'huine',
  'huiva',
  'húme',
  'húna',
  'húnen',
  'hunte',
  'huo',
  'Huore',
  'hurin',
  'húro',
  'huru',
  'húvanimor',
  'hwan',
  'hwarin',
  'hwarma',
  'hwerme',
  'hwesta',
  'hwinde',
  'hya',
  'hyá',
  'hyalin',
  'Hyallondie',
  'hyalma',
  'hyana',
  'hyanda',
  'hyande',
  'hyapat',
  'Hyaralondie',
  'Hyarastorni',
  'hyáre',
  'hyarma',
  'hyarmaite',
  'hyarmen',
  'hyarmenya',
  'hyarna',
  'hyarya',
  'hyatse',
  'hye',
  'hyelle',
  'hyelma',
  'hyóla',
  'i',
  'ia',
  'iale',
  'ie',
  'iel',
  'ien',
  'ier',
  'il',
  'ilaurea',
  'ilce',
  'ilco',
  'Ilcorin',
  'íle',
  'ilfirin',
  'ilin',
  'illi',
  'illo',
  'illon',
  'Illuin',
  'illume',
  'ilm',
  'Ilma',
  'Ilmare',
  'Ilmarin',
  'ilmen',
  'ilpirin',
  'ilqua',
  'ilquen',
  // 'ilsa',
  'Iltániel',
  'ilto',
  'lto',
  'Ilu',
  'ilucara',
  'iluisa',
  'Ilumíre',
  'iluquinga',
  'Ilurambar',
  'iluvala',
  'ilúve',
  'ilvana',
  'ilvanya',
  'ilwe',
  'Ilweran',
  'ilya',
  'ima',
  'imba',
  'Imbar',
  'imbe',
  'imbi',
  'imbit',
  'ímen',
  'imi',
  'imíca',
  'imle',
  'imma',
  'immo',
  'imme',
  'imne',
  'imse',
  'imya',
  'in',
  'ina',
  'na',
  'inca',
  'incáno',
  'incánus',
  'ince',
  'inde',
  'indemma',
  'indi',
  'indil',
  'indis',
  'indo',
  'indóme',
  'indor',
  'indyalme',
  'indyo',
  'inen',
  'inga',
  'ingaran',
  'Ingoldo',
  'Ingole',
  'ingólemo',
  'ingolmo',
  'Ingolonde',
  'ingor',
  'Ingwe',
  'inimeite',
  'inqua',
  'inque',
  // 'insa',
  // 'insangare',
  // 'inse',
  'inte',
  'intye',
  'intyale',
  'inwe',
  'inwis',
  'inwisti',
  'inya',
  'inye',
  'Iolosse',
  'ion',
  'Ipsin',
  'íra',
  'íre',
  'irície',
  'Irilde',
  'írima',
  'irin',
  'Írisse',
  'irmin',
  'Irmo',
  'is',
  'isca',
  'Isil',
  'Isilya',
  'isima',
  'isinte',
  'isqua',
  'isse',
  'ista',
  'Istar',
  'istima',
  'Istimor',
  'istya',
  'istyar',
  'iswa',
  'ite',
  'íta',
  'ita',
  'Itaril',
  'itila',
  'iva',
  'Íverind',
  'Íwerin',
  'ixal',
  'kakainen',
  'kelvar',
  'kemen',
  'Kementári',
  'kwí',
  'kyerme',
  'l',
  'la',
  'lá',
  'lacare',
  'lá ume',
  'lai',
  'laia',
  'laica',
  'laicolasse',
  'laima',
  'laime',
  'laiqua',
  'laiquaninwa',
  'laiquasse',
  'laique',
  'Laiquendi',
  'laira',
  'laire',
  'lairus',
  'laisi',
  'laive',
  'laiwa',
  'lala',
  'lalantila',
  'lalme',
  'Lalwende',
  'láma',
  'laman',
  'lámáre',
  'lámatyáve',
  'lamba',
  'lambe',
  'lambele',
  'lambetengwe',
  'lambina',
  'lámina',
  'lamma',
  'lanat',
  'lanca',
  'lanco',
  'landa',
  'lane',
  'láne',
  'lange',
  'lango',
  'langon',
  'langwi',
  'lanna',
  'lanne',
  'lanta',
  'lantalasselingea',
  'lantalca',
  'lantamindon',
  'lante',
  'lanu',
  'lanwa',
  'lanwe',
  'lanya',
  'lanye',
  'lapatte',
  'lappa',
  'lapse',
  'lár',
  'lar',
  'lára',
  'láre',
  'lárea',
  'larca',
  'larma',
  'lasi',
  'lasse',
  'lassecanta',
  'lasselanta',
  'Lastalaica',
  'láta',
  'látie',
  'latin',
  'latta',
  'latucenda',
  'latya',
  'lau',
  'lauca',
  'laume',
  'laupe',
  'laure',
  'laurea',
  'Laurefindil',
  'Laurelin',
  'Laurelindórinan',
  'laurie',
  'laurina',
  'Laurundo',
  'laustane',
  'laustaner',
  'lauva',
  'lávar',
  'lavaralda',
  'le',
  'lé',
  'léline',
  'lemba',
  'Lembi',
  'lemen',
  'lemenya',
  'lemnar',
  'lempe',
  'lenca',
  'lenda',
  'lende',
  'lenéme',
  'lenge',
  'lenwa',
  'Lenwe',
  'lenwe',
  'lepenque',
  'lepetta',
  'lepenya',
  'lepesta',
  'leo',
  'lepecan',
  'lepende',
  'lepenel',
  'lepente',
  'leper',
  'lepetas',
  'lepinca',
  'lepince',
  'lepsat',
  'lepse',
  'leptafinya',
  'lér',
  'lerembas',
  'lerina',
  'lesta',
  'Lestanóre',
  'leuca',
  'lev',
  'lia',
  'liantasse',
  'liante',
  'líco',
  'lícuma',
  'lie',
  'lil',
  'lillassea',
  'lillo',
  'lilómea',
  'lilótea',
  'limba',
  'limbe',
  'lime',
  'limil',
  'limpa',
  'limpe',
  'lin',
  'linda',
  'lindale',
  'Lindar',
  'lindelea',
  'Lindi',
  'Lindisse',
  'lindo',
  'Lindon',
  'lindórea',
  'Lindórie',
  'lindornea',
  'líne',
  'línen',
  'linganer',
  'linge',
  'lingwe',
  'lingwilóce',
  'linna',
  'linnar',
  'linque',
  'linqui',
  'linta',
  'lintie',
  'lintitinwe',
  'lintulinda',
  'lintyulussea',
  'linya',
  'linyenwa',
  'lion',
  'lipil',
  'lipsa',
  'liquin',
  'liquis',
  'lir',
  'líre',
  'lirilla',
  'lirit',
  'lirulin',
  'lís',
  'lisce',
  'lisse',
  'litse',
  'líva',
  'líve',
  'liyúme',
  'lle',
  'llo',
  'lma',
  'lme',
  'lmo',
  'ló',
  'loa',
  'loar',
  // 'loc',
  'lóce',
  'loende',
  'lohte',
  'loi',
  'loica',
  'loicare',
  'loico',
  'loicolícuma',
  'Loicorin',
  'loima',
  'loipare',
  'loiquete',
  'lomba',
  'lóme',
  'lómea',
  'lómear',
  'lómi',
  'lómin',
  'lón',
  'lóna',
  'londa',
  'londe',
  'londie',
  'lor',
  'lóra',
  'lóralya',
  'lorda',
  'lóre',
  'Lórellin',
  'Lórien',
  'lorna',
  // 'losca',
  'losse',
  'lossea',
  'losselie',
  'lóte',
  'lótefalmarínen',
  'lotse',
  'loxa',
  'loxe',
  'lta',
  'lte',
  'lú',
  'lucando',
  'lucasse',
  'lúce',
  'lucie',
  'lucindo',
  'luime',
  'luina',
  'luine',
  'luinince',
  'lúle',
  'lumba',
  'Lumbar',
  'lumbe',
  'lumbo',
  'lumbule',
  'lúme',
  'lumenyáre',
  'lúmequenta',
  'lúmequentale',
  'lúmequentalea',
  'lún',
  'lúna',
  'lunca',
  'lúne',
  'lúnelinque',
  'lunga',
  'lunganar',
  'lungane',
  'Lungumá',
  'lungumaite',
  'Lúnoronti',
  'lunte',
  'lúre',
  'lúrea',
  'lúsina',
  'lusse',
  'lusta',
  'lúte',
  'lútier',
  'lúto',
  'lúva',
  'lúve',
  'luxo',
  'lye',
  'ma',
  'má',
  'máca',
  'Macalaure',
  'macar',
  'macil',
  'mahalma',
  'Máhan',
  'mahtar',
  'mai',
  'Maia',
  'maica',
  'maile',
  'mailea',
  'maira',
  'Mairen',
  'mairo',
  'Mairon',
  'maita',
  'maite',
  'Maitimo',
  'maivoine',
  'maiwe',
  'mal',
  'Malantur',
  'malarauco',
  'malcane',
  'Malcarauce',
  'malda',
  'maldorne',
  'málime',
  'malina',
  'malinai',
  'malinorne',
  'malle',
  'málo',
  'malo',
  'málos',
  'malta',
  'malwa',
  'máma',
  'mámandil',
  'mamil',
  'man',
  'mána',
  'mana',
  'manaite',
  'manaquenta',
  'manar',
  'mátata',
  'mancale',
  'mande',
  'mando',
  'Mandos',
  'mandu',
  'mandulómi',
  'máne',
  'mane',
  'manen',
  'manna',
  'mannar',
  'mante',
  'manque',
  'manu',
  'manwa',
  'Manwe',
  'manyel',
  'maptale',
  'maqua',
  'már',
  'MarnuFalmar',
  'mára',
  'maranwe',
  'marda',
  'Mardil',
  'mardo',
  'Mardorunando',
  'María',
  'márie',
  'maril',
  'marilla',
  'mart',
  'marta',
  'Martalmar',
  'martan',
  'Martan',
  'marto',
  'marya',
  'mas',
  'massa',
  'masse',
  'masta',
  'masto',
  'mat',
  'mátengwie',
  'mátima',
  'matl',
  'matso',
  'matil',
  'maur',
  'maure',
  'mausta',
  'mavar',
  'mavoite',
  'maxa',
  'maxe',
  'Máya',
  'me',
  'mear',
  'mehtar',
  'méla',
  'mélamar',
  'Melcor',
  'melda',
  'melde',
  'meldo',
  'melehta',
  'melehte',
  'meles',
  'meletya',
  'melima',
  'melin',
  'melindo',
  'melisse',
  'Melko',
  'Melkor',
  'melme',
  'melu',
  'melumatya',
  'melwa',
  'men',
  'ména',
  'mende',
  'méne',
  'Menel',
  'mennai',
  'menta',
  'mente',
  'mentie',
  'menya',
  'meoi',
  'merca',
  'meren',
  'merya',
  'meryale',
  'mesta',
  'met',
  'Metelaire',
  'Meterríve',
  'métima',
  'metta',
  'mi',
  'mici',
  'mie',
  'mil',
  'milca',
  'milme',
  'milya',
  'milye',
  'mille',
  'millo',
  'min',
  'mina',
  'mína',
  'Minalcar',
  'Minardil',
  'minasse',
  'Minastan',
  'Minastir',
  'minasurie',
  'minda',
  'minde',
  'Mindi',
  'mindo',
  'Mindolluin',
  'mindon',
  'mine',
  'mingaránar',
  'minna',
  'Minnónar',
  'minque',
  'minquesta',
  'minta',
  'minte',
  'mintya',
  'minya',
  'Minyarussa',
  'Minyatur',
  'Minyon',
  'miquelis',
  'mir',
  'míre',
  'Míriel',
  'miril',
  'mírima',
  'mirima',
  'Mirimor',
  'mirroanwi',
  'miruvor',
  'mirwa',
  'mis',
  'míse',
  'misil',
  'misse',
  'mista',
  'miste',
  'mitra',
  'mitsa',
  'mitta',
  'Mittalmar',
  'mitya',
  'miule',
  'mixa',
  'mo',
  'moalin',
  'moica',
  'moile',
  'moina',
  'mól',
  'móla',
  'mólanoldorin',
  'mor',
  'morco',
  'mordo',
  'more',
  'móre',
  'mori',
  'móri',
  'morilinde',
  'morion',
  'Mormacil',
  'morna',
  'mornie',
  'móro',
  'morqua',
  'Moryo',
  'móta',
  'muile',
  'muina',
  'múlanoldorin',
  'mulma',
  'mundo',
  'munta',
  'murme',
  'murmea',
  'musse',
  'nalalmino',
  'ná',
  'náce',
  'náha',
  'naháme',
  'Nahar',
  'nahemna',
  'nahom',
  'nahta',
  'nai',
  'naica',
  'naicando',
  'naice',
  'naicele',
  'naicelea',
  'naico',
  'naique',
  'Naira',
  'naira',
  'naire',
  'naite',
  'nal',
  'nalda',
  'nalla',
  'nalme',
  'nalta',
  'Ñaltariel',
  'náma',
  'námie',
  'namárie',
  'namba',
  'Nambarauto',
  'namna',
  'Námo',
  'námo',
  'nampe',
  'nan',
  'Nanar',
  'nanda',
  'nanca',
  'nandaro',
  'nande',
  'nandele',
  'nandelle',
  'nandin',
  'Nando',
  'nando',
  'náne',
  'nangwa',
  'nanwa',
  'nanwe',
  'nápat',
  'nápo',
  'nappa',
  'nar',
  'nár',
  'naraca',
  'narda',
  'náre',
  'Nárie',
  'Narmacil',
  'narmo',
  'Narquelie',
  'Narquelion',
  'Narsil',
  'Narsilion',
  'Narvinye',
  'narwa',
  'narwe',
  'Narya',
  'násan',
  'nasar',
  'náse',
  'násie',
  'nasse',
  'nasta',
  'nat',
  'náto',
  'natse',
  // 'nattire',
  'natyam',
  'natyáme',
  'nauca',
  'Nauco',
  'Naucon',
  'naule',
  'nauro',
  'nause',
  'nauta',
  'náva',
  'náve',
  'Návarot',
  'Návatar',
  'návatengwe',
  'návea',
  'ne',
  // 'nesúme',
  'nea',
  // 'nec-',
  'néca',
  'necce',
  'necel',
  'nehte',
  'nehta',
  'nehtanō',
  'nehtar',
  'nehte',
  'neite',
  'nel',
  'nelce',
  'nelci',
  'nelde',
  'neldea',
  'neldesta',
  'Neldie',
  'Neldion',
  'neldor',
  'neleque',
  'nelesta',
  'nelet',
  'nelle',
  'nelquea',
  // 'nelsat',
  'nelta',
  'neltil',
  'nelya',
  'Nelyafinwe',
  'Nelyo',
  'nen',
  'nén',
  'néna',
  'Nénar',
  'nenda',
  'nende',
  'Nendili',
  'nengwe',
  'nengwea',
  'Nénime',
  'néntalma',
  'nénu',
  'nénuvar',
  'nenya',
  'nerca',
  'nerce',
  'nerdo',
  'neresta',
  'Nermi',
  'nernehta',
  'nersat',
  'nerte',
  'nese',
  'nésa',
  'nése',
  'nessa',
  'nessamelda',
  'Nessaron',
  'nesse',
  'nessele',
  'nessima',
  'nesta',
  'nete',
  'neterque',
  'netil',
  'nette',
  'netya',
  'neuma',
  'neuna',
  'neuro',
  'nexa',
  'néya',
  /* 'ngwen', */
  'ni',
  'ní',
  'níca',
  'níce',
  'nie',
  'Niéle',
  'Niellúne',
  'nienaite',
  'nieninque',
  'nieninquea',
  'Nienna',
  'nier',
  'nierme',
  'Nierninwa',
  'nierwes',
  'nihtil',
  'nil',
  'nilda',
  'nilde',
  'nildo',
  'nille',
  'nilme',
  'nilmo',
  'nimpa',
  'nimpe',
  'nin',
  'nína',
  'nince',
  'ninde',
  'ninquanéron',
  'ninque',
  'ninquisse',
  'ninquiraite',
  'ninwa',
  'ninya',
  'nion',
  'nípa',
  'nique',
  'níquetil',
  'niquetil',
  'niquis',
  'níra',
  'níre',
  'nirme',
  'nirwa',
  'nirwe',
  'nís',
  'nísima',
  'Nísimaldar',
  'Nísinen',
  'nisse',
  'nisto',
  'níte',
  'nitya',
  'nitye',
  'níve',
  'nixe',
  'no',
  'nó',
  'noa',
  'Nócoire',
  'noi',
  'noire',
  'Noirinan',
  'ñol',
  'nóla',
  'Nólaire',
  'ñolda',
  'noldare',
  'noldo',
  'Noldolante',
  'Noldomar',
  'Noldomíre',
  'Noldoquentasta',
  'Noldóran',
  'Noldorinwa',
  'nóle',
  'nóleme',
  'Nólion',
  'Nolme',
  'nolmo',
  'Nolofinwe',
  'Nolondil',
  'nolpa',
  'nolwe',
  'nolya',
  'nóme',
  'Nómesseron',
  // 'ñon',
  // 'ñona',
  'nonda',
  'Nóquelle',
  'nór',
  // 'ñor',
  'nordo',
  'nóre',
  'norie',
  'nórie',
  'nórima',
  'norme',
  'norna',
  'norno',
  'Norno',
  'norolinda',
  'norolle',
  'Norríve',
  'norsa',
  'norta',
  'ñorthus',
  'nortil',
  'norto',
  'nosse',
  'nostale',
  'nostari',
  'nóte',
  'notesse',
  'nótie',
  'nótima',
  'notto',
  'Nótuile',
  'nu',
  'Núaran',
  'nucumna',
  'nuhuinenna',
  'nuine',
  'núla',
  'nulda',
  'núle',
  'nulla',
  'numba',
  'numbe',
  'núme',
  'númea',
  'númeheru',
  'númen',
  // 'Númen(n)óre',
  'Númendor',
  'númenya',
  'Númerrámar',
  // 'númessier',
  'Númevalion',
  'nún',
  'Núnatani',
  'Nunduine',
  'nuntixe',
  'nuquerna',
  'Nurmenel',
  'núra',
  'nurtale',
  'nuru',
  'Nurufantur',
  'nuruhuine',
  'núte',
  'nútil',
  // 'núve',
  'nuxo',
  /* 'nwalca',
  'nwalma',
  'nwalme',
  'nwin', */
  'nyano',
  'nyáre',
  'nyarna',
  'nyarro',
  'nye',
  'nyel',
  'nyelecca',
  'nyelet',
  'nyelle',
  'nyello',
  'nyéni',
  'Nyenna',
  'nyenye',
  'nyére',
  'Ó',
  'o',
  'oa',
  'oar',
  'Oarel',
  'oaris',
  'Oazeldi',
  'ocamna',
  'ócom',
  'occa',
  'ocombe',
  'ohlon',
  'oholima',
  'ohta',
  'ohtacáro',
  'ohtar',
  'oi',
  'oia',
  'Oiacúma',
  'oiala',
  'oiale',
  'oialea',
  // 'oicta',
  'oiencarme Eruo',
  'oilima',
  'oio',
  'Oiomúre',
  'oiórie',
  'oira',
  'oire',
  'olassie',
  'olca',
  'ole',
  'óleme',
  'olla',
  'ollo',
  'olma',
  'olme',
  'Olofantur',
  'olo',
  'olombo',
  'oloire',
  'olor',
  'olórea',
  'Olórin',
  'olos',
  'olosse',
  'olosta',
  'olóte',
  'olpe',
  'olvar',
  'olwa',
  'Olwe',
  'olwen',
  'olya',
  'óma',
  'ómalingwe',
  'ómatengwe',
  'óman',
  'ómataina',
  'óme',
  'ómea',
  'ómen',
  'omentie',
  'omesse',
  'ompa',
  'ómu',
  'on',
  'ondo',
  'Ondonóre',
  'one',
  'ongwe',
  'óni',
  'onna',
  'ono',
  'onóna',
  'onóne',
  'onóre',
  'onóro',
  'onótie',
  'Onótimo',
  'ontamo',
  'ontani',
  'ontar',
  'ontare',
  'ontari',
  'ontarie',
  'ontaril',
  'ontaro',
  'onwe',
  'onya',
  'ópa',
  'opele',
  'opo',
  'orco',
  'ore',
  'óre',
  'órea',
  'óresse',
  'orma',
  'Ormal',
  'orme',
  'orna',
  'orne',
  'ornemalin',
  'oro',
  'Orocarni',
  'orofarne',
  'oromandin',
  'oromar',
  'Orome',
  'Oromet',
  'oron',
  'oronye',
  'oronta',
  'oronte',
  'orosta',
  'orotinga',
  'orqui',
  'orro',
  'orró',
  'orróna',
  'Orrostar',
  'ortil',
  'ortírie',
  'orva',
  'orwa',
  'os',
  'osamnar',
  'ósanwe',
  'óse',
  'oselle',
  'ossa',
  'osse',
  'Osse',
  'osta',
  'ostar',
  'ostime',
  'ostirion',
  'osto',
  'Ostoher',
  'oswe',
  'otoque',
  'otornasse',
  'otorno',
  'otosta',
  'otsea',
  'Otselen',
  'otsat',
  'otso',
  'otsola',
  'ovéa',
  'ovesta',
  'pá',
  'paca',
  'pahta',
  'paime',
  'paimeta',
  'paimesta',
  'palan',
  'palantír',
  'palap',
  'palar',
  'Palarran',
  'palis',
  'palla',
  'palme',
  'palúre',
  'Palúrien',
  'Palurin',
  'pan',
  'panda',
  'pano',
  'panta',
  'pantie',
  // 'paptalasselindeen',
  'parca',
  'parma',
  'parna',
  'passa',
  'pasta',
  'pataca',
  'páva',
  'pávatengwi',
  'pé',
  'pelecco',
  'Pelendur',
  'peler',
  'pella',
  'pelo',
  'Pelóri',
  'peltas',
  'pempe',
  'penda',
  'pende',
  'penna',
  'penquanta',
  'pente',
  'penya',
  'Pereldar',
  'peresta',
  'Perian',
  'perina',
  'perta',
  'phin',
  'phindele',
  'pia',
  'pí',
  'pica',
  'píce',
  'picina',
  'Picinaucor',
  'pie',
  'pilin',
  'pilinehtar',
  'piliningeve',
  'pilu',
  'pilwe',
  'pimpe',
  'pinilya',
  'pince',
  'pinque',
  'pior',
  'pir',
  'pirne',
  'pire',
  'pirinde',
  'pirucendea',
  'pirya',
  'pitya',
  'Pityafinwe',
  'Pityanaucor',
  'Pityo',
  'piucca',
  'piuta',
  'po',
  'poa',
  'poica',
  'pol',
  'polca',
  'polda',
  'poldore',
  'Poldor',
  'Poldórea',
  'pole',
  'pono',
  'póna',
  'ponte',
  'pore',
  'poroce',
  'pota',
  'potai',
  'puhta',
  'punta',
  'púrea',
  'pusta',
  'pustane',
  'putta',
  'quáce',
  'quáco',
  'quain',
  'quaine',
  'quaican',
  'quailepen',
  'quainel',
  'quainque',
  'quaista',
  'qualin',
  'qualme',
  'qualume',
  'quama',
  'quáme',
  'quámea',
  'quanda',
  'quanta',
  'Quantarie',
  'quantemma',
  'quantien',
  'quáre',
  'quea',
  'quean',
  'quelet',
  'quelie',
  'quelle',
  'quén',
  'quende',
  'Quendelie',
  'Quendendil',
  'Quenderin',
  'Quendi',
  'quendi',
  'Quendingoldo',
  'quendu',
  'Quendya',
  'quent',
  'quenta',
  'quentale',
  'quentaro',
  'quentasta',
  'quentele',
  'quenya',
  'queren',
  'querma',
  'quesse',
  'quesset',
  'quessetéma',
  'quetil',
  'quetta',
  'qui',
  'quie',
  'quilde',
  'quile',
  'quilta',
  'químari',
  'quimelle',
  'quín, quíne',
  'quinna',
  'quinde',
  'quinga',
  'quingi',
  'quiquie',
  'quín',
  'quorin',
  'rá',
  'racina',
  'ráca',
  'raica',
  'raima',
  'raime',
  'raina',
  'raine',
  'raiwe',
  'ráma',
  'rámalóce',
  'rámavoite',
  'ramba',
  'rambe',
  'rámen',
  'ran',
  'Rána',
  'ránasta',
  'ranco',
  'randa',
  'ráne',
  'ránen',
  'ranga',
  'rangwe',
  'ranqui',
  'ranta',
  'ranya',
  'Rása',
  'rasco',
  'rasse',
  'rasta',
  'rato',
  'rau',
  'rauca',
  'rauco',
  'raumo',
  'raust',
  'ravanda',
  'ráva',
  'rávea',
  'ravenne',
  'raxa',
  'raxe',
  // 're',
  'ré',
  'rehtie',
  'rembe',
  'rembina',
  'remma',
  'rempa',
  'réna',
  'rende',
  'resta',
  'ría',
  'ríe',
  'rie',
  'riel',
  'rille',
  'rilma',
  'rilya',
  'ríma',
  'rimba',
  'rimbe',
  'rimpa',
  'rin',
  'rína',
  'rinca',
  'rince',
  'rinda',
  'rinde',
  'Ringare',
  'ringe',
  'Ringil',
  'ringwe',
  'risil',
  'risse',
  'rista',
  'RithilAnamo',
  'roa',
  // 'rocca',
  'rocco',
  'rocindi',
  'rohta',
  'roime',
  'roina',
  'róma',
  'romba',
  'Róme',
  'rómen',
  'rómenya',
  'ronco',
  'ronda',
  'rondo',
  'ronta',
  'ronya',
  'roquen',
  'rosse',
  'rosta',
  'róta',
  'rotele',
  'rotse',
  'rotto',
  'rotwa',
  'Rú',
  'rúcare',
  'rúcima',
  'rúcina',
  'rucindi',
  'ruhta',
  'ruimen',
  'ruina',
  'ruine',
  'ruive',
  'Rúmil',
  'runando',
  'runda',
  'rúnya',
  'runya',
  'rusca',
  'rusco',
  'ruscuite',
  'rúse',
  'rúsea',
  'russa',
  'Russandol',
  'russe',
  'rusta',
  'ruste',
  'rúvina',
  'sa',
  'sarince',
  'sá',
  'saccante',
  'Sahóra',
  'saila',
  'saira',
  'sairina',
  'sairon',
  'saiwa',
  'salma',
  'Salmar',
  'salme',
  'salpa',
  'salque',
  'sáma',
  'sambe',
  'samin',
  'saminda',
  'samna',
  'samnar',
  'samno',
  'sámo',
  'sampa',
  'san',
  'sana',
  'sanar',
  'Sanavaldo',
  'sanca',
  'sance',
  'Sancossi',
  'sanda',
  'sandastan',
  'sáne',
  'sanga',
  'sangie',
  // 'sangane',
  'sangwa',
  'sanome',
  'sanwe',
  'sanwecenda',
  'sanwelatya',
  'sanwementa',
  'sanya',
  'sanye',
  'sapsanta',
  'sar',
  'sára',
  'sara',
  'sarat',
  'sarco',
  'sarcuva',
  'sarda',
  'sarda tengwe',
  'sarme',
  'sarna',
  'sarne',
  'sarnie',
  'sarno',
  'sarqua',
  'Sarquindi',
  'sarta',
  'sarto',
  'satar',
  'satto',
  'satya',
  'sau',
  'saucare',
  'saucarya',
  'sauna',
  'saura',
  'Sauro',
  // 'sauro',
  'sáva',
  'Sáya',
  'se',
  'selda',
  'selde',
  'seldo',
  'seler',
  'selli',
  'selma',
  'selye',
  'sén',
  'sena',
  'senda',
  'sende',
  'senna',
  'senwa',
  'serce',
  'sére',
  'Serinde',
  'serme',
  'sermo',
  'seron',
  // 'setta',
  'si',
  'sí',
  'siar',
  'sicil',
  'sie',
  'sildaránar',
  // 'sildai',
  'silde',
  'silima',
  'sillume',
  'silma',
  'Silmarien',
  'Silmaril',
  'silme',
  'Silmeráno',
  'Silmerosse',
  'silo',
  'Silpion',
  'silquelosseen',
  'silume',
  'síma',
  'simen',
  'simpa',
  'simpetalla',
  'simpetar',
  'simpina',
  'simpise',
  'sin',
  'sina',
  'sína',
  'sincahonda',
  'sinda',
  'sindarinwa',
  'sinde',
  'sindie',
  'sinen',
  'Sindel',
  'sindi',
  'Sindicollo',
  'Sindo',
  'singe',
  'singwa',
  'Singollo',
  'sinome',
  'sinqui',
  'sinquitálar',
  'sinta',
  'sintamo',
  'sinte',
  'sinwa',
  'sinya',
  'sinye',
  'sio',
  'sir',
  'sír',
  'síra',
  'síre',
  'siril',
  'sirilla',
  'sírima',
  'Siriondil',
  'sirpe',
  'sirya',
  'sís',
  'sisíla',
  'sisse',
  'Sistar',
  'siste',
  'site',
  'siule',
  'síve',
  'soa',
  'soica',
  'solme',
  'Solonel',
  'sól',
  'solma',
  'solor',
  'solos',
  'solosse',
  'sóma',
  'sondo',
  'songa',
  'sor',
  'sóra',
  'sorna',
  'sornion',
  'sorno',
  'soron',
  'Sorontar',
  'Soronúme',
  'sovalle',
  'sú',
  'suhte',
  'suhto',
  'sulca',
  'súle',
  'súlimarya',
  'Súlime',
  'Súlimo',
  'súlo',
  'sulpa',
  'súma',
  'sundo',
  'sundóma',
  'sungwa',
  'súre',
  'surie',
  'súriquesse',
  'Súro',
  'súru',
  'surya',
  // 'súyer',
  'ta',
  'tá',
  'tai',
  'taile',
  'taima',
  'Taimavar',
  'Taime',
  'Taimondo',
  'taina',
  'taite',
  'tál',
  'talaite',
  'talan',
  'talantie',
  'talas',
  'talca',
  'tallune',
  'talma',
  'talo',
  'talume',
  'talta',
  'taltil',
  'taltol',
  'tama',
  'taman',
  'tambaro',
  'tambe',
  'tambina',
  'tamen',
  'tamin',
  'tamma',
  'tamna',
  'tamo',
  'tampa',
  'tampe',
  'tampo',
  'tana',
  'tána',
  'tanca',
  'tance',
  'tancil',
  'Tancol',
  'tande',
  'tanen',
  'tango',
  'tangwa',
  'taniquelasse',
  'Taniquetil',
  'tanna',
  'tano',
  'tanome',
  'tanta',
  'tantila',
  'tanwa',
  'tanwe',
  'tanya',
  'tapta',
  'tar',
  'tár',
  'tara',
  'tára',
  'taracu',
  'taran',
  'Tarannon',
  'taras',
  'tarasse',
  'tarca',
  'tarcalion',
  'Tarculu',
  'Tarcil',
  'táre',
  'Tareldar',
  'tarhildi',
  'tári',
  'tárie',
  'Tárion',
  'táris',
  'tarma',
  'tarmen',
  'Tarmenel',
  'tarminas',
  'tarna',
  'Tarnumen',
  'Tarondor',
  'Tarostar',
  'tarquendi',
  'taru',
  'tarucca',
  'tarucco',
  'Taruhtarna',
  'tarunco',
  'tarwa',
  'tarwe',
  'tarya',
  'taryo',
  'tás',
  'tasar',
  'tasarin',
  'Tasarinan',
  'tassa',
  'tasse',
  'tastil',
  'táta',
  'tatanya',
  'tatya',
  'tauca',
  'taule',
  'tauno',
  'taura',
  'taure',
  'Taure Huinéva',
  'taurea',
  'taurelasselindon',
  'Taurelilómeatumbalemorna Tumbaletaurea Lómeanor',
  'Tauremorna',
  'tauretavárea',
  'taurina',
  'tautamo',
  'táva',
  'tavar',
  'tavárea',
  'Tavari',
  'tavaril',
  'tavaro',
  'tavas',
  'taxe',
  'te',
  'tea',
  'tecco',
  'tecil',
  'tehta',
  'tel',
  'telar',
  'telco',
  'Telcontar',
  'telda',
  'telella',
  'Telelle',
  'Telellie',
  'Telemmaite',
  'telemna',
  'Telemnar',
  'telempe',
  'telep',
  'telepta',
  'Teler',
  'telerea',
  'Telerin',
  'telerinwa',
  'Telumehtar',
  'telimbo',
  'tella',
  'telle',
  'telluma',
  'telma',
  'telme',
  'telpe',
  'telpina',
  'telqui',
  'teltasse',
  'Telufinwe',
  'telume',
  'téma',
  'ten',
  'téna',
  'tencele',
  // 'tenge',
  'tengwa',
  'tengwanda',
  'tengwe',
  'tengwele',
  'tengwesta',
  'tengwestie',
  'tengwie',
  'tenna',
  'tenne',
  'tennoio',
  'ter',
  'téra',
  'tercáno',
  'tercen',
  'teren',
  'Terendul',
  'teret',
  'tereva',
  'terfantie',
  'terpellie',
  'terra',
  // 'tet',
  'tévie',
  'tevin',
  // 'th' to 's'
  /* 'Thauron',
  'thelma',
  'thenna',
  'Therinde',
  'thinde',
  'Thindicollo',
  'tholon',
  'thorno',
  'thosso',
  'thúle', */
  'tie',
  'tien',
  'tier',
  'tilde',
  'tille',
  'Tilion',
  'timbare',
  'timpe',
  'timpine',
  'timpinen',
  'tinco',
  'tinda',
  'tinde',
  'tindóme',
  'tindómerel',
  'Tindómiel',
  // 'tindon',
  // 'tíne',
  'tinge',
  'tingilinde',
  'tingilya',
  'Tintalle',
  'Tintanie',
  'tinwe',
  'tinwelindon',
  'Tinwerína',
  // 'Tinwerontar',
  // 'Tinwetar',
  'tirin',
  'tirion',
  'tirios',
  'tiris',
  'titta',
  'tiuca',
  'tiuco',
  'tiutale',
  'tixe',
  'tó',
  'toa',
  'tocot',
  'toi',
  'toina',
  'tol',
  // 'Tol Eressea',
  'toldea',
  'toldo',
  'tóle',
  'tollalinta',
  'tollanta',
  'tolle',
  'tollo',
  'tolma',
  'tolmen',
  // 'tolmo',
  'toloque',
  'tolos',
  'tolosta',
  'tolpe',
  'tolpo',
  'tomba',
  // 'tolsat',
  'toltea',
  // 'toltil',
  'tolto',
  'tolvo',
  'tolyo',
  'tombo',
  'tompe',
  'tópa',
  // 'Tormen',
  'torna',
  'tornanga',
  'torni',
  'toron',
  'torwa',
  'tosta',
  'tú',
  // 'tucalia',
  'tuile',
  'tuilére',
  'tuilindo',
  'tuima',
  'tulca',
  'tulco',
  'Tulkas',
  'tulma',
  'tulunca',
  'tulwe',
  'túma',
  'tumba',
  'tumbe',
  'tumbo',
  'Tumbolatsin',
  'tumna',
  'tumpo',
  'Túna',
  'tunda',
  'tundo',
  'tunga',
  'tuo',
  'tupse',
  'tur',
  'túr',
  'túra',
  'Turambar',
  'Turcafinwe',
  'Turcil',
  'turco',
  'túre',
  'turea',
  'Túrin',
  'turinasta',
  'turindie',
  'Turindo',
  'turinqui',
  'túrion',
  'turma',
  'turmen',
  'turne',
  'Turondo',
  'Túrosto',
  'turu',
  'Turucáno',
  'Turumbar',
  'turun',
  'turúna',
  'turúva',
  'tussa',
  'tusture',
  'tyalangan',
  'tyalie',
  'tyaro',
  'tyáve',
  'tye',
  'tyel',
  'tyelca',
  'Tyelcormo',
  // 'tyelde',
  'tyelima',
  'tyelle',
  'tyelma',
  'tyelpe',
  'Tyelperinquar',
  'tyelpetéma',
  'Tyelperion',
  'tyulma',
  'tyulusse',
  'tyur',
  'ú',
  'úa',
  'Úamanyar',
  'úcare',
  'úcarindo',
  'ue',
  'úfantima',
  'úfanwa',
  'úfanwea',
  'ufárea',
  'ui',
  'uie',
  'uile',
  'uin',
  'Uin',
  'Uinen',
  'uito',
  'úχarin',
  'Úlairi',
  'ulca',
  'ulco',
  'úlea',
  'ulle',
  'ullume',
  'Ulmo',
  'ulmula',
  'úlume',
  'ulumpe',
  'Ulumúri',
  'ulunde',
  'ulundo',
  'Úmaneldi',
  'Úmanyar',
  'umaquale',
  'umba',
  'umbar',
  'Umbardacil',
  'Umbarto',
  'umbas',
  'umbo',
  'úme',
  'Úmaiar',
  'úmea',
  'umne',
  'umpano',
  'un',
  'úna',
  'únat',
  'Undolaure',
  'undóme',
  'undu',
  'undume',
  'Úner',
  'ungo',
  'Ungoliante',
  'ungwale',
  'ungwe',
  'Ungweliante',
  'unote',
  'únótima',
  'unqua',
  'unquale',
  'unque',
  'unuhuine',
  'unutixe',
  'únyárima',
  // 'uo',
  'úpa',
  'úpahtea',
  'úquétima',
  'úr',
  'Úranar',
  'úra',
  'urcárima',
  'urco',
  'urda',
  'urdu',
  'úre',
  'úri',
  'Úrime',
  'úrin',
  'Úrin',
  'Úrion',
  'urna',
  'úro',
  'urta',
  'ur',
  'urnótima',
  'uru',
  'urucarin',
  'uruite',
  'urulóce',
  'Urundil',
  'urus',
  'úruva',
  'uruvoite',
  'urwa',
  'ursa',
  // 'us-',
  'úsahtie',
  'uscare',
  'úsie',
  'úsir',
  'usque',
  'uswe',
  'Uswevande',
  'utúlien',
  'Utumno',
  'utúvienyes',
  'úva',
  'úvana',
  'úvane',
  'úvanima',
  'úvanimo',
  'úvea',
  'úvie',
  'uxare',
  // 'úye',
  'va',
  'vá',
  'vacco',
  'vaháya',
  'vaia',
  'vaile',
  'vailima',
  'Vaiaro',
  'vaima',
  'vaina',
  'vaine',
  'vainole',
  'Vaire',
  'vaire',
  'vaiwe',
  'vaiwa',
  'Vala',
  'Valacar',
  'Valacirca',
  'Valandil',
  'Valandur',
  'valaina',
  'Valandor',
  'Valanya',
  'Valaquenta',
  'Valarauco',
  'Valariande',
  'Valarin',
  'Valarindi',
  'Valaróma',
  'valasse',
  'Valatar',
  'Valatári',
  'valcane',
  'Valcarauce',
  'vald',
  'valda',
  'Valde',
  'valdea',
  'Valie',
  'Valimar',
  'valimo',
  'valin',
  'Valinor',
  'Valis',
  'Valmar',
  'Valmo',
  'Valon',
  // 'Valsi',
  'valta',
  'valto',
  'valya',
  'ván',
  'Vána',
  'Vanar',
  'vand',
  'vanda',
  'vandl',
  'vane',
  'váne',
  'vanesse',
  'vanga',
  'vangwe',
  'vanie',
  // 'vánie',
  'vanima',
  'vanimalda',
  'Vanimelde',
  'Vanimo',
  // 'vanne',
  'vanta',
  'vanwa',
  'vanwie',
  'vanya',
  'var',
  'vára',
  'varanda',
  'Varda',
  'vardar',
  'Vardilme',
  'Vardo Meoita',
  'varna',
  'varnasse',
  'varne',
  'varni',
  'varile',
  'Vása',
  'vasar',
  'vávea',
  've',
  'vea',
  'veaciryo',
  'Veandur',
  'veaner',
  'Veantur',
  'veasse',
  'vecca',
  'vehte',
  'vehtequentale',
  'velca',
  'velice',
  // "v'ematte",
  'véna',
  'vende',
  'vene',
  'véne',
  'vénea',
  'venesse',
  'venie',
  'venno',
  'venta',
  'venwe',
  'veo',
  'véra',
  'verca',
  'vére',
  'Vére',
  'veri',
  'verie',
  'verno',
  'veru',
  'veryanwe',
  'vesse',
  'vesta',
  'vestale',
  'vet',
  'vi',
  'vie',
  // 'vilda',
  'víle',
  'vilin',
  'vilisse',
  'vilte',
  'vilwa',
  'vilya',
  'vinca',
  'Vincarna',
  // 'vinde',
  'vine',
  'víne',
  'Vingelot',
  'vinima',
  'vinimo',
  'vinya',
  'Vinyamar',
  'vinyamo',
  'Vinyarie',
  // 'vinye',
  'Víresse',
  'vírie',
  'vírin',
  'virya',
  'vista',
  'vó',
  'vor',
  'vora',
  'vóre',
  'vórea',
  'vorima',
  'vórima',
  'voro',
  'vorongandele',
  'voronda',
  'Vorondil',
  'voronwa',
  'voronwe',
  'voronwie',
  'vorosanya',
  'wa',
  'wá',
  'wai',
  'waia',
  'waile',
  'waina',
  'waita',
  'waiwa',
  'walda',
  'walme',
  'walwiste',
  'wán',
  'wanwa',
  'wanwavoite',
  'waþar',
  'we',
  'wén',
  'wen',
  'wenci',
  'wende',
  'wendele',
  'wendi',
  'wéne',
  'wente',
  'wenya',
  'weo',
  'wéra',
  'wet',
  // 'wilda',
  'wilin',
  'wilma',
  'wilwa',
  'wilwarin',
  'wilwarindea',
  'wilya',
  'winca',
  'wince',
  'winda',
  'winde',
  'windele',
  'windya',
  'wine',
  'winga',
  'winge',
  'Wingelot',
  'wingil',
  'wingilot',
  'winice',
  'winima',
  'winimo',
  'wintil',
  'winya',
  'winyamo',
  'Wirilóme',
  'wirne',
  'wiste',
  'xe',
  'yá',
  'ya',
  'yaht',
  'yaima',
  'yaime',
  'yaimea',
  'yaisa',
  'yaiwe',
  'yallume',
  'yalme',
  'yalte',
  'yalúme',
  'yalúmea',
  'yalúmesse',
  'yáme',
  'yan',
  'yána',
  'yana',
  'yanda',
  'yando',
  'yanta',
  'yanwe',
  'yar',
  'yár',
  'yára',
  'yáre',
  'yárea',
  'yáresse',
  'yarra',
  'yaru',
  'yasse',
  'yat',
  'yatta',
  'yaule',
  'yáva',
  'yávan',
  'Yavanna',
  'yavannamíre',
  'Yavannie',
  'Yavannildi',
  'yáve',
  'yávie',
  'Yávien',
  'yáwe',
  'yaxe',
  'ye',
  'yé',
  'yea',
  'yelca',
  'yelda',
  'yelde',
  'Yelin',
  'yello',
  'yelma',
  'yelme',
  'yelwa',
  'yén',
  'yen',
  'yendi',
  'yenya',
  'yeo',
  'yére',
  'yerna',
  'yesta',
  'yestare',
  'Yésus',
  // 'yéva',
  'yo',
  'yó',
  'yomenie',
  'Yón',
  'yón',
  'yonda',
  'yonde',
  'yondo',
  'yonna',
  'yonwa',
  'yonya',
  'yonyo',
  'yór',
  // 'yu-',
  'yuale',
  'yúcale',
  'yúla',
  'yulda',
  'yulma',
  'yulme',
  'yunce',
  'yunque',
  'yunquenta',
  'yunquesta',
  'yurasta',
  'yúyal',
  'yúyo',
];

export const VERBS = [
  'accar-',
  'ahya-',
  'aina-',
  'airita-',
  'aista-',
  'al-',
  'ala-',
  'alála-',
  'alta-',
  'alya-',
  'amorta-',
  'amu-',
  'amya-',
  'anta-',
  'ap-',
  'appa-',
  'apsene-',
  'arca-',
  'arya-',
  'ascat-',
  'asya-',
  'asta-',
  'atalta-',
  'ataquanta-',
  'auta-',
  'av-',
  'ava-',
  'avaquet-',
  'avatyar-',
  'caita-',
  'cal-',
  'calpa-',
  'calta-',
  'calya-',
  'cam-',
  'camta-',
  'can-',
  'cap-',
  'car-',
  'carasta-',
  'carpa-',
  'cav-',
  'caw-',
  'cen-',
  'cenda-',
  'ces-',
  'cesta-',
  'ceuta-',
  'cim-',
  'cir-',
  'cíta-',
  'col-',
  'comya-',
  'costa-',
  'cúna-',
  'ea-',
  'ecces-',
  'eccoita',
  // 'effir-', // ff?
  'empanya-',
  'endaquet-',
  'enquanta-',
  'enquete-',
  'enyal-',
  'er-',
  'erca-',
  'esta-',
  'ethenta-',
  'etelehta-',
  'eterúna-',
  'etsat-',
  'ettul-',
  'faina-',
  'fainu-',
  'falasta-',
  'fanta-',
  'farya-',
  'fasta-',
  'fauta-',
  'fifíru-',
  'finta-',
  'fir-',
  'fur-',
  'haca-',
  'halta-',
  'halya-',
  'ham-',
  'hanta-',
  'hanya-',
  'har-',
  'harna-',
  'harya-',
  'hasta-',
  'hauta-',
  'hehta-',
  'henta-',
  'heru-',
  'hesta-',
  'hilya-',
  'hir-',
  'hiuta-',
  'hlapu-',
  'hlar-',
  'hloita-',
  'hóciri-',
  'holya-',
  'holta-',
  'horta-',
  'hosta-',
  'hranga-',
  'hrir-',
  'hum-',
  'húna-',
  'hund-',
  'hur-',
  'húta-',
  'hwesta-',
  'hwinya-',
  'hyam-',
  'hyan-',
  'hyar-',
  'ilca-',
  'intya-',
  'ista-',
  'ita-',
  'lahta-',
  'laita-',
  'lala-',
  'lamya-',
  'langa-',
  'lanya-',
  'lapsa-',
  'laquet-', // t?
  'lasta-',
  'latya-',
  'lav-',
  'lehta-',
  'lelta-',
  'lelya-',
  'lemya-',
  'lenca-',
  'lenda-',
  'lenga-',
  'lenna-',
  'lenu-',
  'lenta-',
  'lenweta-',
  'lepta-',
  'leptenta-',
  'lerya-',
  'lerta-',
  'lesta-',
  'lia-',
  'lilta-',
  'linda-',
  'linga-',
  'lipta-',
  'lir-',
  'lohta-',
  'loita-',
  'lom-',
  'losta-',
  'luhta-',
  'luita-',
  'lumna-',
  'lussa-',
  'lutta-',
  'lutu-',
  'luvu-',
  'mac-',
  'maca-',
  'mahta-',
  'mala-',
  'manca-',
  'manta-',
  'manwa-',
  'manya-',
  'mapa-',
  'mapta-',
  'maquet-',
  'mar-',
  'marta-',
  'martya-',
  'masta-',
  'mat-',
  'mauya-',
  'mel-',
  'men-',
  'menta-',
  'mer-',
  'metya-',
  'milya-',
  'miqu-',
  'mirilya-',
  'mista-',
  'mitta-',
  'mittanya-',
  'moc-',
  'moia-',
  'mol-',
  'moru-',
  'muru-',
  'na-',
  'nac-',
  'naham-',
  'naina-',
  'nainaina-',
  'naiquet-',
  'naitya-',
  'nam-',
  'namba-',
  'nancar-',
  'nanda-',
  'nanwen-',
  'napan-',
  'narca-',
  'narta-',
  'nasta-',
  'nattira-', // without -a?
  'nav-',
  'nehta-',
  // 'nes-',
  'netya-',
  'nev-',
  'nicu-',
  'ninquita-',
  'ninquitá-',
  'nir-',
  'nor-',
  'nornoro-',
  'norta-',
  'nosta-',
  'not-',
  'nuhta-',
  'numenda-',
  'númeta-',
  'nurru-',
  'nurta-',
  'núru-',
  'nut-',
  'núta-',
  /* 'nwalya-', */
  'nyar-',
  'nyéna-',
  // 'ócama-',
  'ócom-',
  'ohtacar-',
  'ol',
  'óla',
  'oloiya-',
  'onot-',
  'onta-',
  'or-',
  'órava-',
  'oro-',
  'orta-',
  // 'orto-',
  'orya-',
  'paitya-',
  'pal-',
  'palpa-',
  'palta-',
  'palu-',
  'palya-',
  'panta-',
  'panya-',
  'par-',
  'pasta-',
  'pata-',
  'peanta-',
  'pel-',
  'pelehta-',
  'pen-',
  'penda-',
  'penga-',
  'perya-',
  'pet-',
  'píca-',
  'piuta-',
  'poita-',
  'pol-',
  'pusta-',
  'qual-',
  'quanta-',
  'quapta-',
  'quat-',
  'quel-',
  'quer-',
  'quet-',
  'quir-',
  'quoro-',
  'rac-',
  'rahta-',
  'raita-',
  'rama-',
  'ranya-',
  'ráta-',
  'rauta-',
  'rea-',
  'rem-',
  'remba-',
  'rer-',
  'ric-',
  'rihta-',
  'rista-',
  'roita-',
  'ruc-',
  'ruhta-',
  'rúma-',
  'rúna-',
  'ruxa-',
  'saca-',
  'sahta-',
  'salpa-',
  'sam-',
  'sap-',
  'sat-',
  'sav-',
  'sen-',
  'ser-',
  'sesta-',
  'sil-',
  'sisilcala-',
  'sinta-',
  'sir-',
  'sovo-',
  'suc-',
  // 'sulp-',
  'súya-',
  'tac-',
  'taita-',
  'talat-',
  'talta-',
  'tam-',
  'tamba-',
  'tana-',
  'tap-',
  'tar-',
  'tarwesta-',
  'tatya-',
  'tec-',
  'tele-', // without -e?
  'telta-',
  'telya-',
  'ten-',
  'tengwa-',
  'tenta-',
  'tenya-',
  'terhat-',
  'termar-',
  'teve-',
  // 'th' to 's'
  /* 'thorya-',
  'thosta-', */
  'tihta-',
  'tin-',
  'tinga-',
  'tinta-',
  'tintila-',
  'tintina-',
  'tir-',
  'tiuta-',
  'tiuya-',
  'tolu-',
  'top-',
  'tópa-',
  // 'tóquet-',
  'tuc-',
  'tuia-',
  'tul-',
  'tulca-',
  'tulta-',
  'tulu-',
  'tulya-',
  'tunda-',
  'tup-',
  'tur-',
  'turu-',
  'tuv-',
  'tuvu-',
  'tyal-',
  'tyar-',
  'tyasta-',
  'tyav-',
  'tyel-',
  'u-',
  'ua-',
  'úcar-',
  'ulto-',
  'ulu-',
  'ulya-',
  'um-',
  'úma-',
  'umbarta-',
  'unca-',
  'undulav-',
  'untup-',
  'urya-',
  'ursa-',
  'us-',
  'usta-',
  'uva-',
  'vahta-',
  'vaita-',
  'vala-',
  'vanta-',
  'vanya-',
  'váquet-',
  'vard-',
  'varya-',
  'vasarya-',
  // 'váva-',
  'vel-',
  'verta-',
  'verya-',
  'vesta-',
  'vil-',
  // 'vinda-',
  // 'vinta-',
  'virya-',
  'vista-',
  'walta-',
  'walya-',
  // 'wáya-',
  'were-',
  'wil-',
  'winta-',
  'yal-',
  'yam-', // with a-?
  'yanga-',
  'yantya-',
  'yav-',
  'yelta-',
  'yerya-',
  'yesta-',
  'yéta-',
  'yor-',
  // 'yulu-',
  'yur-',
];

export const WORDS = corpus
  .filter((e) => e.length === MAX_WORD_LENGTH && wordValidation(e))
  .map((e) => e.toLocaleLowerCase());
